<!-- Alerts Panel (ALERT-001 to ALERT-015) -->
<div class="alerts-panel" *ngIf="showAlertsPanel && alerts.length > 0">
  <div class="alerts-panel-header">
    <h3>Active Alerts ({{ unreadAlertsCount }})</h3>
    <button mat-icon-button (click)="toggleAlertsPanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="alerts-panel-content">
    <div *ngFor="let alert of alerts.slice(0, 5)" class="alert-item" [ngClass]="'severity-' + alert.severity">
      <mat-icon>{{ alert.severity === 'critical' || alert.severity === 'high' ? 'error' : 'warning' }}</mat-icon>
      <div class="alert-item-content">
        <strong>{{ alert.title }}</strong>
        <p>{{ alert.message }}</p>
      </div>
      <button *ngIf="alert.alert_type === 'boq_bid_received' && alert.metadata?.invitation_id" 
              mat-icon-button (click)="viewBids(alert)" title="View Bids">
        <mat-icon>visibility</mat-icon>
      </button>
      <button *ngIf="alert.alert_type === 'boq_bidding_invitation' && alert.metadata?.bidding_link" 
              mat-icon-button (click)="viewAndSubmitBid(alert)" title="View & Submit Bid">
        <mat-icon>gavel</mat-icon>
      </button>
      <button *ngIf="alert.alert_type === 'boq_bid_awarded' && alert.metadata?.project_id" 
              mat-icon-button (click)="viewAwardedProjectFromAlert(alert)" title="View Project">
        <mat-icon>account_tree</mat-icon>
      </button>
      <button *ngIf="!['boq_bidding_invitation','boq_bid_received','boq_bid_approved','boq_bid_declined','boq_bid_awarded'].includes(alert.alert_type)" 
              mat-icon-button (click)="acknowledgeAlert(alert)" title="Acknowledge">
        <mat-icon>check_circle</mat-icon>
      </button>
    </div>
    <button mat-button (click)="navigateToAlerts()" class="view-all-alerts">
      View All Alerts
    </button>
  </div>
</div>

<!-- Alerts Button -->
<div class="alerts-button-container">
  <button mat-fab color="warn" (click)="toggleAlertsPanel()" [matBadge]="unreadAlertsCount" matBadgeColor="warn" matBadgeOverlap="false">
    <mat-icon>notifications</mat-icon>
  </button>
</div>

<!-- Subscription Expiry Alert (SUB-009) -->
<div *ngIf="showExpiryAlert && expiryAlertData" 
     class="expiry-alert-container"
     [ngClass]="{'expiry-alert-urgent': expiryAlertData.daysRemaining <= 3, 'expiry-alert-expired': expiryAlertData.daysRemaining === 0}">
  <div class="expiry-alert-content">
    <div class="expiry-alert-icon">
      <mat-icon>{{ expiryAlertData.daysRemaining === 0 ? 'error' : expiryAlertData.daysRemaining <= 3 ? 'warning' : 'info' }}</mat-icon>
    </div>
    <div class="expiry-alert-text">
      <h4 class="expiry-alert-title">{{ expiryAlertData.daysRemaining === 0 ? 'Subscription Expired' : 'Subscription Expiring Soon' }}</h4>
      <p class="expiry-alert-message">{{ expiryAlertData.message }}</p>
      <p class="expiry-alert-date" *ngIf="expiryAlertData.expiryDate">
        Expiry Date: {{ expiryAlertData.expiryDate | date: 'mediumDate' }}
      </p>
    </div>
    <div class="expiry-alert-actions">
      <button mat-raised-button 
              [color]="expiryAlertData.daysRemaining === 0 ? 'warn' : 'primary'"
              (click)="navigateToRenewal()">
        <mat-icon>card_membership</mat-icon>
        Renew Now
      </button>
      <button mat-icon-button (click)="closeExpiryAlert()" title="Dismiss">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<!-- Dashboard Header -->
<div class="dashboard-header">
  <div class="header-content">
    <h1 class="dashboard-title">
      <mat-icon class="title-icon">dashboard</mat-icon>
      {{'DASHBOARD_OVERVIEW' | translate}}
    </h1>
    <p class="dashboard-subtitle">
      <ng-container *ngIf="!isScopedUser">{{ 'DASHBOARD_DESC' | translate }}</ng-container>
      <ng-container *ngIf="isScopedUser">Your assigned projects and personal workspace overview.</ng-container>
    </p>
  </div>
  <div class="header-actions">
    <button mat-raised-button color="primary" (click)="refreshData()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>

<!-- Loading State -->
<div class="loading-state" *ngIf="loading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading dashboard data...</p>
</div>

<!-- Main Dashboard Content -->
<div *ngIf="!loading && dashboradData" class="dashboard-content">
  
  <!-- Key Metrics Overview -->
  <div class="metrics-overview">
    <div class="metric-card primary" *ngIf="!isScopedUser">
      <div class="metric-icon">
        <mat-icon>people</mat-icon>
      </div>
      <div class="metric-content">
        <h3 class="metric-title">{{'TOTAL_USERS'| translate}}</h3>
     <a routerLink="/home/employees">    <p class="metric-value">{{ dashboradData.user_stats_total || 0 }}</p></a>
        <p class="metric-subtitle">{{ 'DASHBOARD_METRIC_USERS_SUBTITLE' | translate: { staff: dashboradData.staff_count || 0, admin: dashboradData.user_count || 0 } }}</p>
      </div>
    </div>

    <div class="metric-card warning">
      <div class="metric-icon">
        <mat-icon>assignment</mat-icon>
      </div>
      <div class="metric-content" >
        <h3 class="metric-title">{{ isScopedUser ? 'My Projects' : ('PROJECTS_BOMS'| translate) }}</h3>
      <a routerLink="/home/projects">  <p class="metric-value">{{ dashboradData.project_stats_total || dashboradData.projects_count || 0 }}</p> </a>
        <p class="metric-subtitle" *ngIf="!isScopedUser">{{ 'DASHBOARD_METRIC_PROJECTS_SUBTITLE' | translate: { count: dashboradData.projects_count || 0 } }}</p>
        <p class="metric-subtitle" *ngIf="isScopedUser">Projects assigned to you</p>
      </div>
    </div>

    <div class="metric-card info" *ngIf="!isScopedUser">
      <div class="metric-icon">
        <mat-icon>card_membership</mat-icon>
      </div>
      <div class="metric-content">
        <h3 class="metric-title">{{'DOMAIN_'| translate}}</h3>
      <a routerLink="/home/subscription">    <p class="metric-value">{{ users?.user.domainCount || 0 }}</p></a>
        <p class="metric-subtitle">{{ 'DASHBOARD_METRIC_DOMAIN_SUBTITLE' | translate: { name: (users?.user?.domain || '—') } }}</p>
      </div>
    </div>

    <div class="metric-card accent" *ngIf="!isScopedUser">
      <div class="metric-icon">
        <mat-icon>gavel</mat-icon>
      </div>
      <div class="metric-content">
        <h3 class="metric-title">{{ 'DASHBOARD_BID_DATA_TITLE' | translate }}</h3>
        <a routerLink="/home/boq"><p class="metric-value">{{ 'DASHBOARD_BOQ_BIDDING' | translate }}</p></a>
        <p class="metric-subtitle">{{ 'DASHBOARD_BID_DATA_DESC' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Awarded Projects (for Bidders) -->
  <div *ngIf="awardedProjects?.length" class="awarded-projects-section">
    <h2 class="section-title">
      <mat-icon>gavel</mat-icon>
      Projects Awarded to You
    </h2>
    <div class="awarded-projects-grid">
      <div *ngFor="let project of awardedProjects" class="awarded-project-card">
        <div class="awarded-project-header">
          <h3>{{ project.project_name }}</h3>
          <span class="boq-badge">{{ project.boq_code }}</span>
        </div>
        <p class="awarded-project-detail">{{ project.boq_name }}</p>
        <p class="awarded-project-amount">{{ formatCurrency(project.bid_amount) }}</p>
        <p class="awarded-project-date">Awarded: {{ formatDate(project.awarded_at) }}</p>
        <button mat-stroked-button color="primary" (click)="viewAwardedProjectWBS(project)">
          <mat-icon>account_tree</mat-icon>
          View My WBS
        </button>
      </div>
    </div>
  </div>

  <!-- Project Locations Map Section -->
  <div class="map-section">
    <!-- Map Header -->
    <div class="map-header">
      <div class="map-title">
        <mat-icon class="title-icon">place</mat-icon>
        <h2>{{ isScopedUser ? 'My Project Locations' : ('PROJECT_LOCATIONS'| translate) }}</h2>
        <span class="project-count">{{ 'DASHBOARD_MAP_PROJECT_COUNT' | translate: { count: projectLocations.length } }}</span>
      </div>
      <div class="map-controls">
        <button mat-icon-button (click)="refreshData()" matTooltip="Refresh">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>

    <!-- Map Legend -->
    <div class="map-legend">
      <div class="legend-item">
        <span class="legend-color" style="background-color: #ef4444;"></span>
        <span>{{'STATUS_NEW'| translate}}</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" style="background-color: #3b82f6;"></span>
        <span>{{'STATUS_PLANNING'| translate}}</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" style="background-color: #f59e0b;"></span>
        <span>{{'STATUS_SURVEY_DESIGN'| translate}}</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" style="background-color: #10b981;"></span>
         <span>{{'STATUS_EXECUTION'| translate}}</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" style="background-color: #8b5cf6;"></span>
        <span>{{'STATUS_CLOSURE'| translate}}</span>

      </div>
    </div>

    <!-- Map and Projects Container -->
    <div class="map-projects-container">
      <!-- OpenLayers Map Container -->
      <div class="map-container">
        <div #olMapContainer class="ol-map"></div>

        <!-- No Projects Overlay -->
        <div class="no-projects-overlay" *ngIf="projectLocations.length === 0">
          <div class="no-projects-content">
            <mat-icon class="no-projects-icon">location_off</mat-icon>
            <h3>{{'NO_PROJECT_LOCATIONS'| translate}}</h3>
            <p>{{'MAP_EMPTY_TEXT'| translate}}</p>
          </div>
        </div>
      </div>

      <!-- Project Details Popup (Outside map container, positioned absolutely) -->
      <div class="project-popup-overlay" *ngIf="selectedProject" (click)="closePopup()">
        <div class="project-popup-card" (click)="$event.stopPropagation()">
          <button class="popup-close-btn" (click)="closePopup()">
            <mat-icon>close</mat-icon>
          </button>
          
          <div class="popup-card-header" [style.background]="'linear-gradient(135deg, ' + getStageColor(selectedProject.stage) + ' 0%, ' + getDarkerColor(getStageColor(selectedProject.stage)) + ' 100%)'">
            <div class="popup-card-avatar">
              {{ selectedProject.project_name?.charAt(0)?.toUpperCase() || 'P' }}
            </div>
            <div class="popup-card-title">
              <h3>{{ selectedProject.project_name }}</h3>
              <span class="popup-card-id">#{{ selectedProject.id }}</span>
            </div>
            <span class="popup-stage-badge">
              {{ selectedProject.stage || 'New' }}
            </span>
          </div>

          <div class="popup-card-body">
            <div class="popup-detail-item">
              <mat-icon>category</mat-icon>
              <div class="detail-content">
                <span class="detail-label">Domain</span>
                <span class="detail-value">{{ selectedProject.domain?.trim() || 'N/A' }}</span>
              </div>
            </div>

            <div class="popup-detail-item" *ngIf="selectedProject.budget_amount">
              <mat-icon>currency_rupee</mat-icon>
              <div class="detail-content">
                <span class="detail-label">Budget</span>
                <span class="detail-value">{{ formatCurrency(selectedProject.budget_amount) }}</span>
              </div>
            </div>

            <div class="popup-detail-item">
              <mat-icon>event</mat-icon>
              <div class="detail-content">
                <span class="detail-label">Duration</span>
                <span class="detail-value">{{ formatDate(selectedProject.timeline_start) }} - {{ formatDate(selectedProject.timeline_end) }}</span>
              </div>
            </div>

            <div class="popup-detail-item" *ngIf="selectedProject.locationInfo">
              <mat-icon>location_on</mat-icon>
              <div class="detail-content">
                <span class="detail-label">Location</span>
                <span class="detail-value">
                  {{ selectedProject.locationInfo.address_line_1 || '' }}
                  {{ selectedProject.locationInfo.city ? (selectedProject.locationInfo.address_line_1 ? ', ' : '') + selectedProject.locationInfo.city : '' }}
                  {{ selectedProject.locationInfo.state ? ', ' + selectedProject.locationInfo.state : '' }}
                </span>
              </div>
            </div>
          </div>

          <div class="popup-card-footer">
            <button mat-button class="popup-btn-secondary" (click)="centerMapOnProject(selectedProject)">
              <mat-icon>my_location</mat-icon>
              Center Map
            </button>
            <button mat-raised-button color="primary" class="popup-btn-primary" (click)="viewProjectDetails(selectedProject)">
              <mat-icon>visibility</mat-icon>
              View Details
            </button>
          </div>
        </div>
      </div>

      <!-- Projects List Sidebar -->
      <div class="projects-list-container">
        <div class="projects-list-header">
          <h3>{{ 'DASHBOARD_PROJECTS_LIST_TITLE' | translate }}</h3>
          <span class="projects-count">{{ projectLocations.length }}</span>
        </div>
        
        <div class="projects-list" *ngIf="projectLocations.length > 0">
          <div 
            *ngFor="let project of projectLocations" 
            class="project-item"
            [class.selected]="selectedProject?.id === project.id"
            (click)="selectProjectFromList(project)"
          >
            <div class="project-header">
              <div class="project-avatar">
                <div class="avatar-circle" [style.background-color]="getStageColor(project.stage)">
                  {{ project.project_name?.charAt(0)?.toUpperCase() || 'P' }}
                </div>
              </div>
              <div class="project-info">
                <p class="project-name">{{ project.project_name }}</p>
                <span class="project-id">#{{ project.id }}</span>
              </div>
              <div class="project-stage">
                <span class="stage-badge" [style.background-color]="getStageColor(project.stage)">
                  {{ project.stage || 'New' }}
                </span>
              </div>
            </div>
            
            <div class="project-details">
              <div class="detail-row">
                <mat-icon class="detail-icon">category</mat-icon>
                <span class="detail-text">{{ project.domain?.trim() || 'N/A' }}</span>
              </div>
              <div class="detail-row" *ngIf="project.locationInfo?.city">
                <mat-icon class="detail-icon">location_on</mat-icon>
                <span class="detail-text">{{ project.locationInfo.city }}{{ project.locationInfo.state ? ', ' + project.locationInfo.state : '' }}</span>
              </div>
            </div>

            <div class="project-actions">
              <button mat-icon-button class="action-btn" (click)="centerMapOnProject(project); $event.stopPropagation()" matTooltip="Show on map">
                <mat-icon>my_location</mat-icon>
              </button>
              <button mat-icon-button class="action-btn" (click)="viewProjectDetails(project); $event.stopPropagation()" matTooltip="View details">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="empty-projects-list" *ngIf="projectLocations.length === 0">
          <mat-icon class="empty-icon">folder_off</mat-icon>
          <h4>{{'NO_PROJECTS'| translate}}</h4>
          <p>{{'NO_PROJECTS_LOCATION'| translate}}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Detailed Statistics Grid -->
  <div class="statistics-grid">
    
    <!-- User Management Section -->
    <div *ngIf="false" class="stat-section">
      <h2 class="section-title">
        <mat-icon>people</mat-icon>
        User Management
      </h2>
      <div class="stat-cards">
        <div class="stat-card" [routerLink]="['/home/employees']">
          <div class="stat-header">
            <mat-icon class="stat-icon">person</mat-icon>
            <span class="stat-label">Staff Members</span>
          </div>
          <div class="stat-value">{{ dashboradData.staff_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/users']">
          <div class="stat-header">
            <mat-icon class="stat-icon">person_outline</mat-icon>
            <span class="stat-label">Regular Users</span>
          </div>
          <div class="stat-value">{{ dashboradData.user_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/company']">
          <div class="stat-header">
            <mat-icon class="stat-icon">business</mat-icon>
            <span class="stat-label">Organizations</span>
          </div>
          <div class="stat-value">{{ dashboradData.organization_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/organization-branch-list', org_id]">
          <div class="stat-header">
            <mat-icon class="stat-icon">account_tree</mat-icon>
            <span class="stat-label">Branches</span>
          </div>
          <div class="stat-value">{{ dashboradData.branches_count || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- Project Management Section -->
    <div *ngIf="false" class="stat-section">
      <h2 class="section-title">
        <mat-icon>assignment</mat-icon>
        Project Management
      </h2>
      <div class="stat-cards">
        <div class="stat-card" [routerLink]="['/home/projects']">
          <div class="stat-header">
            <mat-icon class="stat-icon">folder</mat-icon>
            <span class="stat-label">Active Projects</span>
          </div>
          <div class="stat-value">{{ dashboradData.projects_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/bom']">
          <div class="stat-header">
            <mat-icon class="stat-icon">inventory_2</mat-icon>
            <span class="stat-label">Bill of Materials</span>
          </div>
          <div class="stat-value">{{ dashboradData.boms_count || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- Business Section -->
    <div class="stat-section">
      <h2 class="section-title">
        <mat-icon>business_center</mat-icon>
        {{'BUSINESS'|translate}}
      </h2>
      <div class="stat-cards">
        <div class="stat-card" [routerLink]="['/home/clients']">
          <div class="stat-header">
            <mat-icon class="stat-icon">people_alt</mat-icon>
            <span class="stat-label">{{'CLIENTS'|translate}}</span>
          </div>
          <div class="stat-value">{{ dashboradData.clients_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/subscriptions']">
          <div class="stat-header">
            <mat-icon class="stat-icon">card_membership</mat-icon>
            <span class="stat-label">{{'ACTIVE_SUBSCRIPTIONS' | translate}}</span>
          </div>
          <div class="stat-value">{{ dashboradData.subscriptions_count || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- Resources Section -->
    <div *ngIf="true" class="stat-section">
      <h2 class="section-title">
        <mat-icon>inventory</mat-icon>
        {{'RESOURCES_MATERIALS' | translate}}
      </h2>
      <div class="stat-cards">
        <div class="stat-card" [routerLink]="['/home/materials']">
          <div class="stat-header">
            <mat-icon class="stat-icon">construction</mat-icon>
            <span class="stat-label">{{'MATERIALS'| translate}}</span>
          </div>
          <div class="stat-value">{{ dashboradData.materials_count || 0 }}</div>
        </div>

        <div class="stat-card" [routerLink]="['/home/machine-master']">
          <div class="stat-header">
            <mat-icon class="stat-icon">category</mat-icon>
            <span class="stat-label">{{'MACHINES' | translate}}</span>
          </div>
          <div class="stat-value">{{ dashboradData.machines_count || 0 }}</div>
        </div>

        <div *ngIf="false" class="stat-card" [routerLink]="['/home/documents']">
          <div class="stat-header">
            <mat-icon class="stat-icon">description</mat-icon>
            <span class="stat-label">Documents</span>
          </div>
          <div class="stat-value">{{ dashboradData.documents_count || 0 }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Summary Cards -->
  <div *ngIf="false" class="summary-section">
    <div class="summary-card total d-none">
      <div class="summary-content">
        <h3>Total Entities</h3>
        <p class="summary-value">{{ dashboradData.total_count || 0 }}</p>
        <p class="summary-description">All tracked items in the system</p>
      </div>
      <div class="summary-icon">
        <mat-icon>analytics</mat-icon>
      </div>
    </div>

    <div class="summary-card resources">
      <div class="summary-content">
        <h3>Resources</h3>
        <p class="summary-value">{{ dashboradData.resource_stats_total || 0 }}</p>
        <p class="summary-description">Materials, categories & documents</p>
      </div>
      <div class="summary-icon">
        <mat-icon>inventory</mat-icon>
      </div>
    </div>
  </div>
</div>

<!-- Error State -->
<div class="error-state" *ngIf="!loading && !dashboradData">
  <mat-icon class="error-icon">error_outline</mat-icon>
  <h3>Unable to load dashboard data</h3>
  <p>Please try refreshing the page or contact support if the issue persists.</p>
  <button mat-raised-button color="primary" (click)="fetchData()">
    <mat-icon>refresh</mat-icon>
    Try Again
  </button>
</div>
